import { gql } from "graphql-request"

export default gql`
    query ($siteId: [QueryArgument], $slug: [String], $draftId: Int, $revisionId: Int, $status: [String]) {
        data: entry(
            siteId: $siteId
            section: "loginRegister"
            slug: $slug
            draftId: $draftId
            revisionId: $revisionId
            status: $status
        ) {
            title
            ... on loginRegister_Entry {
                seoMetaTitle
                seoMetaDescription
                copy: description
                loginButtonCopy: string2
                leaderboardAdLoginRegisterPage
                lockup: image {
                    url
                }
                pageBackgroundMedia {
                    url
                }
            }
        }
    }
`
